<template>
   <div>
       <h3 class="modal-title mb-0 text-dark-green" v-if="type === 'menu'">
           <i class="text-dark-green me-2 opacity-75 fi fi-rr-utensils"></i>
           {{ trans('general.page.planners.menu') }}
       </h3>
       <h3 class="modal-title me-2 text-blue" v-if="type === 'activity'">
           <i class="text-blue opacity-75  fi fi-rr-triangle"></i>
           {{ trans('general.page.planners.activities') }}
       </h3>
       <h3 class="modal-title me-2 text-pink" v-if="type === 'event'">
           <i class=" opacity-75  fi fi-rr-calendar"></i> {{ trans('general.page.planners.events') }}
       </h3>
       <h3 class="modal-title me-2 text-warning" v-if="type === 'appointment'">
           <i class=" opacity-75  fi fi-rr-clock"></i> {{ trans('general.page.planners.appointment') }}
       </h3>
   </div>
</template>
<script>
import translator from '../../../VueTranslation/Translation'

export default {
    name: "MenuForm",
    props: {
        type: String,
    },

    methods: {
      trans(key) {
          return translator.translate(key)
      }
    }
}
</script>
